import request from '@/config/axios'

// AI 视频 VO
export interface VideoVO {
  id: number // 编号
  userId: number // 用户编号
  picUrl: string // 视频地址
  videoUrl:string
  status: number // 音乐状态
  prompt: string // 提示词
  platform: string // 模型平台
  model: string // 模型
  publicStatus: boolean // 是否发布
  taskId: string // 任务id
  errorMessage: string // 错误信息
  createTime:Number // 创建时间
  categoryName:string // 分类名称
   options: {
    model: string
    ratio: string
    style: string
    prompt: string
    modelId: string
    options: string
    callback_url: string
  }
}


// AI 视频 VO
export interface VideoRecommendVo {
  id: number |undefined // 编号
  framePosition: number // 1=首帧，2=尾帧
  frameImageUrl: string // 图片地址
  createTime:Number |undefined // 创建时间
}


// AI 音乐 API
export const VideoApi = {

  //详情
  getVideoDetail: async (id: Number) => {
    return await request.get({ url: `/ai/video/get?id=${id}`})
  },

  // 分页
  getVideoPage: async (params: any) => {
    return await request.get({ url: `/ai/video/page`, params })
  },

  // 更新
  updateMVideoA: async (data: any) => {
    return await request.put({ url: '/ai/video/update', data })
  },

  // 删除
  deleteVideo: async (id: number) => {
    return await request.delete({ url: `/ai/video/delete?id=` + id })
  },

  // 发布审核
  auditsPublishVideo: async (data:{id:Number,publicStatus:Boolean}) => {
    return await request.post({ url: '/ai/video/audits-publish',data});
  },

  // 申请发布审核
  applyPublishVideo: async (data:{id:Number,applyPublish:Boolean}) => {
    return await request.post({ url: '/ai/video/apply-publish',data});
  },

  // 设置分类
   category: async (data :{id:number,categoryName:string}) => {
    return await request.post({ url: '/ai/video/category' ,data});
    },

  //首尾帧详情
  getVideoRecommendDetail: async (id: Number) => {
    return await request.get({ url: `/ai/video-frame-recommend/get?id=${id}`})
  },

  // 首尾帧分页
  getVideoRecommendPage: async (params: any) => {
    return await request.get({ url: `/ai/video-frame-recommend/page`, params })
  },

  // 首尾帧创建
  createRecommend: async (data: any) => {
    return await request.put({ url: '/ai/video-frame-recommend/create', data })
  },


  // 首尾帧更新
  updateVideoRecommend: async (data: any) => {
    return await request.put({ url: '/ai/video-frame-recommend/update', data })
  },

  // 首尾帧删除
  deleteVideoRecommend: async (id: number) => {
    return await request.delete({ url: `/ai/video-frame-recommend/delete?id=` + id })
  },


}
